import { Pricing as PricingBase } from "@omni/components/components/Product/ECommerce/components/pricing/pricing";

import { PricingComponent } from "@/components/Product/ECommerce/components/pricing/pricing.component";

export const Pricing = () => {
    return (
        <PricingBase>
            <PricingComponent />
        </PricingBase>
    );
};
